import React, { useEffect } from 'react';
import { STEPS } from '../../utils/constants/progressSteps';
import useHandleFormInput from './hooks/useHandleFormInputHook';
import Input from './Input';
import PhoneInput from './PhoneInput';
import styles from './AccountForm.module.scss';
import { useAppContext } from '../../utils/ContextProviders/AppContext';
import { useFriendContext } from '../../utils/ContextProviders/FriendContext';
import { validateAccountForm } from './utilities/accountFormUtilities';
import { postSendVerificationPhoneCode } from '../../utils/Data/registerConnector';
import { trackEvent } from '../../utils/tracking';
import { useVerifyUniquePhoneNumber } from './hooks/useVerifyUniquePhoneNumber';

function AccountForm() {
  const { viewSize, flags, goToStep } = useAppContext();
  const { formState, handleOnChange, setFormState } = useHandleFormInput();
  const { verifyUniquePhoneNumber } = useVerifyUniquePhoneNumber();
  const { setFriend, friend } = useFriendContext();

  function handleSubmit() {
    goToStep(STEPS.VERIFY);
    setFriend(Object.assign(friend, formState));
    // @ts-ignore
    if (verifyUniquePhoneNumber(flags)) {
      postSendVerificationPhoneCode(friend?.phoneNumber);
      trackEvent('Login Submitted', friend, 'CONTINUE');
    }
  }

  function handleCountrySelect(countryCode: string) {
    setFriend(Object.assign(friend, { countryCode }));
  }

  const {
    email,
    firstName,
    lastName,
    phoneNumber,
    password,
  } = formState;

  // populate form from friend
  useEffect(() => {
    if (friend.email) {
      setFormState({ ...friend });
    }
  }, [friend]);

  return (
    <>
      <section className={`${styles.accountForm} ${styles[viewSize]}`}>
        <div>
          <h1 className={styles.title}>Create Login</h1>
          <p className={styles.desc}>Get temporary access to Shop with Friends!</p>
        </div>
        <form>
          <div>
            <Input
              type="text"
              label="Email Address"
              value={email}
              name="email"
              placeholder="Enter email address"
              maxLength={320}
              handleInput={handleOnChange}
              errorMessage="Please enter a valid email address."
            />
            <Input
              type="text"
              label="First Name"
              value={firstName}
              name="firstName"
              placeholder="Enter first name"
              maxLength={30}
              handleInput={handleOnChange}
              errorMessage="This field is required."
            />
            <Input
              type="text"
              label="Last Name"
              value={lastName}
              name="lastName"
              placeholder="Enter last name"
              maxLength={30}
              handleInput={handleOnChange}
              errorMessage="This field is required."
            />
            <PhoneInput
              label="Mobile Number (to receive verification code)"
              value={phoneNumber}
              name="phoneNumber"
              handleInput={handleOnChange}
              handleCountrySelect={handleCountrySelect}
              errorMessage="This field is required."
            />
            <Input
              type="password"
              label="Password"
              value={password}
              name="password"
              placeholder="Create password"
              maxLength={256}
              handleInput={handleOnChange}
              errorMessage="Your password does not meet our requirements. "
            />
          </div>
          <button type="button" disabled={!validateAccountForm(formState, friend)} className={styles.button} onClick={handleSubmit}>Continue</button>
        </form>
      </section>
    </>
  );
}

export default AccountForm;
